// Latest confluence per symbol so the order ticket can snapshot the setup state at entry.
const latest = new Map();
export const confluenceStore = {
  set: (symbol, tf, result) => latest.set(symbol, { tf: tf.id, result, at: Date.now() }),
  get: (symbol) => latest.get(symbol) ?? null,
  snapshot(symbol) {
    const e = latest.get(symbol);
    if (!e?.result) return null;
    const r = e.result;
    return {
      timeframe: e.tf, time: r.time, bull: r.bull, bear: r.bear, bias: r.bias,
      components: Object.fromEntries(r.components.map((c) => [c.id, { bull: c.bull, bear: c.bear, state: c.state }])),
    };
  },
};
